import React from "react";
import { Shield, Clock, Star, Users, Award, ShieldCheck } from "lucide-react";

/**
 * Trust block (USP) — three pillars displayed under the wizard.
 * Inspired by the user-supplied reference: "SICHER & ZUVERLÄSSIG",
 * "PÜNKTLICH & FLEXIBEL", "KOMFORT & QUALITÄT".
 */
const TRUST_ITEMS = [
  {
    icon: ShieldCheck,
    title: "Sicher & Zuverlässig",
    subtitle: "Safe & Reliable",
    desc: "Vollkasko-Versicherung inkl., CHF 1'000 Selbstbehalt — Sie fahren sorgenfrei.",
  },
  {
    icon: Clock,
    title: "Pünktlich & Flexibel",
    subtitle: "On Time & Flexible",
    desc: "Online buchen in unter 3 Minuten. Übergabe Mo–Di und Do–So von 08:00–20:00.",
  },
  {
    icon: Award,
    title: "Komfort & Qualität",
    subtitle: "Comfort & Quality",
    desc: "Gepflegte Mercedes Vito und Renault Master. Vollgetankt — keine Überraschungen.",
  },
];

const VALUES_ITEMS = [
  { icon: Shield, label: "Ihr Transport.", sub: "Unser Anspruch." },
  { icon: Star, label: "Modern, neutral,", sub: "hochwertig." },
  { icon: Users, label: "Familienorientiert.", sub: "Persönlicher Service." },
];

export const TrustSection = () => (
  <section className="bg-white border-t border-[var(--rs-border)]" data-testid="trust-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-14">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        {TRUST_ITEMS.map((t) => {
          const I = t.icon;
          return (
            <div key={t.title} className="text-center" data-testid={`trust-${t.title.replace(/\s/g, "-").toLowerCase()}`}>
              <div className="inline-flex items-center justify-center w-20 h-20 bg-black rounded-full mb-5">
                <I size={36} className="text-[#D4AF37]" strokeWidth={1.5} />
              </div>
              <h3 className="font-[Chivo] text-xl font-black uppercase tracking-tight">{t.title}</h3>
              <div className="text-xs uppercase tracking-[0.2em] text-[var(--rs-text-muted)] mt-1">{t.subtitle}</div>
              <p className="text-sm text-[var(--rs-text-muted)] leading-relaxed mt-4 max-w-xs mx-auto">{t.desc}</p>
              <div className="w-10 h-[3px] bg-[#D4AF37] mx-auto mt-5"></div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export const ValuesSection = () => (
  <section className="bg-[var(--rs-surface)] border-t border-[var(--rs-border)]" data-testid="values-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
        {VALUES_ITEMS.map((v) => {
          const I = v.icon;
          return (
            <div key={v.label} className="flex items-center gap-4">
              <div className="w-12 h-12 border border-[var(--rs-text)] flex items-center justify-center flex-shrink-0">
                <I size={22} className="text-[var(--rs-primary)]" strokeWidth={1.5} />
              </div>
              <div>
                <div className="font-[Chivo] text-sm font-black uppercase tracking-tight">{v.label}</div>
                <div className="text-xs text-[var(--rs-text-muted)] mt-0.5">{v.sub}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
